import React from 'react'
import * as actionCreators from '../../../actions/RouterActions'
import {Table, Popup, Icon, Loader, Button, Card} from 'semantic-ui-react'
import {useFirebase, useFirestore, useFirestoreConnect, useFirebaseConnect} from 'react-redux-firebase';
import {useSelector} from 'react-redux';
import {env} from '../../../constants/Environment';

export function Elementslist(props) {
    const firebase = useFirebase()
    const firestore = useFirestore();

    useFirestoreConnect([
        { collection: 'environments/' + env + '/channels/app/home', doc: 'content' }
    ])

    /*const users = useSelector(({firestore: {ordered}}) => {
        if(ordered['environments/' + env + '/users']){
            let lsort = _.clone(ordered['environments/' + env + '/users']);
            lsort.sort((a, b) => {
                if(a.lastname.localeCompare(b.lastname) !== 0)return a.lastname.localeCompare(b.lastname);
                return a.firstname.localeCompare(b.firstname);
            });
        
            return lsort;
        }else{
            return [];
        }
    });*/
    //const dispatch = useDispatch()

    //const state = props.state;
    
    return (
        <div>
            <div style={{
                padding: '10px',
                color: '#777777'
            }}>
                <div>
                    <Card raised={true}>
                        <Card.Content>
                            <Card.Header>Hero-Teaser</Card.Header>
                            <Card.Meta>
                                <span className='date'>Sichtbar in allen Lotterien</span>
                            </Card.Meta>
                        </Card.Content>
                        <Card.Content extra>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <div style={{
                                    flexGrow: 1
                                }}>
                                    Element verschieben
                                </div>
                                <div>
                                    <Button basic disabled size="small" circular icon>
                                        <Icon name="arrow up" />
                                    </Button>
                                    <Button basic size="small" circular icon>
                                        <Icon name="arrow down" />
                                    </Button>
                                </div>
                            </div>
                        </Card.Content>
                        <Card.Content extra>
                            <div style={{
                                display: 'flex'
                            }}>
                                <Button size="small" color='orange' style={{
                                    flexGrow: 1,
                                    flexBasis: 1
                                }}>
                                    Deaktivieren
                                </Button>
                                <Button size="small" color='red' style={{
                                    flexGrow: 1,
                                    flexBasis: 1
                                }}>
                                    Löschen
                                </Button>
                            </div>
                        </Card.Content>
                    </Card>
                </div>
            </div>
        </div>
    )
}